export { Chip } from '@mantine/core'
